import { Ctas } from "../shared";
import { useReader } from "../ReaderContext";

export const AdPage = ({ page }) => {
  const { edition } = useReader();
  return (
    <article className="mag-page" data-testid={`mag-page-${page.n}`} lang={edition?.lang} dir={edition?.dir || "ltr"}>
      <img src={page.image} alt={page.title} className="mag-img absolute inset-0" />
      <div className="absolute inset-x-0 bottom-0" style={{ height: 320, background: "linear-gradient(180deg, rgba(25,25,25,0) 0%, rgba(25,25,25,0.72) 100%)" }} />
      <div className="absolute top-6 left-6 mag-kicker" style={{ color: "#fff", background: "rgba(25,25,25,0.55)", padding: "5px 9px", fontSize: 8 }} data-testid={`page-${page.n}-ad-label`}>{page.kicker}</div>
      <div className="absolute left-8 right-8" style={{ bottom: 64 }}>
        {page.title && <h2 className="mag-head" style={{ fontSize: 46, color: "#fff" }}>{page.title}</h2>}
        {page.deck && <p className="mag-deck mt-2" style={{ color: "var(--platinum)" }}>{page.deck}</p>}
        <Ctas page={page} className="mt-5" />
      </div>
      <div className="absolute bottom-5 left-8 right-8 flex justify-between mag-kicker" style={{ color: "rgba(255,255,255,0.6)", fontSize: 7.5 }}>
        <span>{page.note}</span><span>{String(page.n).padStart(2, "0")}</span>
      </div>
    </article>
  );
};
